<template>
  <div class="container">
    <section class="section">
      <span class="title is-3">{{ empresa.nombrec }}</span>
      <small class="title is-5"
        >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
      >
      <small class="subtitle is-7">{{ empresa.nombre }}</small>
      <hr />
      <h1 class="title is-4">Instrucciones:</h1>
      <p>
        En este módulo podrá importar terceros o registros. Para ello deberá
        crear un archivo de excel con los datos a importar. Este archivo lo
        deberá guardar con <strong>formato .xlsx</strong>
        <span class="tag is-primary">xlsx</span> y la estructura de las columnas
        según los datos a importar es la siguiente:
      </p>
      <br />
      <h1 class="title is-5">Importar Registros</h1>
      <span class="tag">cuenta</span>
      <span class="tag">nit</span>
      <span class="tag">descripcion</span>
      <span class="tag">comp</span>
      <span class="tag">doc</span>
      <span class="tag">docRef</span>
      <span class="tag">ccostos</span>
      <span class="tag">vbase</span>
      <span class="tag">t</span>
      <span class="tag">valor</span>
      <span class="tag">dia</span>
      <span class="tag">mes</span>
      <span class="tag">year</span>
      <span class="tag">codprod</span>
      <span class="tag">vlrUnit</span>
      <span class="tag">bodega</span>
      <span class="tag">lote</span>
      <span class="tag">nlote</span>
      <span class="tag">cantidad</span>
      <span class="tag">vendedor</span>
      <br /><br />
      <div class="columns">
        <div class="column is-2">
          <button class="button is-link" @click="downexemplereg">
            Descargar Ejemplo
          </button>
        </div>
        <div class="column">
          <div class="file has-name">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                accept=".xlsx"
                ref="file"
                @change="onFileChange"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <span class="material-icons">attach_file</span>
                </span>
                <span class="file-label">Seleccione un Archivo… </span>
              </span>
              <span class="file-name">{{ filename }}</span>
            </label>
          </div>
        </div>
        <div class="column">
          <button class="button is-link" @click="submitFile">
            <span class="file-icon">
              <span class="material-icons">cloud_upload</span>
            </span>
            <span> Subir </span>
          </button>
        </div>
        <div class="column">
          <button class="button is-link" @click="saveregistros">
            <span class="file-icon">
              <span class="material-icons">save</span>
            </span>
            <span> Guardar </span>
          </button>
        </div>
        <!-- <div class="column">
          <button class="button is-link" @click="probar">
            <span class="file-icon">
              <span class="material-icons">save</span>
            </span>
            <span> probar </span>
          </button>
        </div> -->
      </div>
      <hr />
      <h1 class="title is-5">Importar terceros</h1>
      <div class="notification">
        <small>
          Al subir los terceros se debe indicar el tipo de tercero, el país y la
          ciudad. Si no se le agrega este dato o el dato esta mal diligenciado
          el sistema automáticamente cambiara estos parametros a: <br />
          1. El tipo lo configurará a Persona Jurídica. <br />
          2. El país lo configurará como Colombia (<span class="fontMono"
            >169</span
          >). <br />
          3. La ciudad lo configurará a Medellín. (<span class="fontMono"
            >05-001</span
          >).</small
        ><br /><br />
        En la columan tipo debe ingresar 1 Si es Persona Jurídica, 2 Si es
        Persona Natural y 3 Si es un código extranjero. Si selecciona la opción
        2, es bueno separar los nombres y apellidos en cada columna, el sistema
        dejará importar la información si no la tiene separada pero después
        tendrá que separarla si quiere que el reporte de medios magnéticos salga
        correctamente. <br />
        En ciudad y país debe colocar el código de la siguiente manera: ejemplo
        Medellín: 05-001. Colombia: 169.
      </div>
      <span class="tag">nit</span>
      <span class="tag">tipo</span>
      <span class="tag">razon</span>
      <span class="tag">nombre1</span>
      <span class="tag">nombre2</span>
      <span class="tag">apellido1</span>
      <span class="tag">apellido2</span>
      <span class="tag">direccion</span>
      <span class="tag">correo</span>
      <span class="tag">celular</span>
      <span class="tag">ciudad</span>
      <span class="tag">telefono</span>
      <span class="tag">pais</span>
      <span class="tag">regimen</span>
      <span class="tag">postalcode</span>

      <br /><br />
      <div class="columns is-multiline">
        <div class="column is-2">
          <button class="button is-link" @click="downexemplenits">
            Descargar Ejemplo
          </button>
        </div>
        <div class="column is-10">
          <div class="field">
            <div class="file is-light">
              <label class="file-label" style="margin-left: 10px">
                <input
                  class="file-input"
                  type="file"
                  accept=".xls, .xlsx"
                  @change="onFileChange1"
                  name="resume"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="material-icons">cloud_upload</i>
                  </span>
                  <span class="file-label">Cargar desde Excel</span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <progress
            v-show="avaceupload > 0"
            class="progress is-info is-small"
            :value="avaceupload"
            max="100"
          ></progress>
        </div>
      </div>
      <div class="columns" v-if="error">
        <div class="column">
          <div class="notification is-warning">
            <button class="delete" @click="closenotification"></button>
            <h1 class="title is-4">{{ error.reason }}</h1>
            <h2 class="subtitle" v-show="error.n">Registro {{ error.n }}</h2>
            <pre class="has-background-warning" v-show="error.reg">{{
              error.reg
            }}</pre>
          </div>
        </div>
      </div>
      <div class="columns" v-show="resumen.length > 0">
        <div class="column">
          <table class="table fontMono is-striped is-narrow is-fullwidth">
            <thead>
              <tr>
                <th>Comprobante</th>
                <th>Periodo</th>
                <th>Documento</th>
                <th class="has-text-right">Debito</th>
                <th class="has-text-right">Credito</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in resumen" :key="index">
                <td>
                  <strong
                    >{{ item.comprobante.codigo }} -
                    {{ item.comprobante.nombre }}</strong
                  >
                </td>
                <td>{{ item._id.year }}-{{ item._id.mes }}</td>
                <td>{{ item._id.documento }}</td>
                <td class="has-text-right">
                  {{ item.debito | number() }}
                </td>
                <td class="has-text-right">
                  {{ item.credito | number() }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      filename: "Seleccionar archivo",
      file: "",
      error: null,
      resumen: [],
      avaceupload: 0,
      query: {
        url: "",
      },
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    async probar() {
      try {
        const result = await apiServices.get(`/testupload`);
        console.log(result.data);
      } catch (err) {
        console.log(err);
      }
    },
    async saveregistros() {
      try {
        const result = await apiServices.get(`/saveregitrosupload`);
        if (result.data && result.data.message === "Registros Guardados") {
          this.resumen = [];
          this.file = "";
          this.filename = "Seleccionar archivo";
        }
      } catch (err) {
        console.log(err);
      }
    },
    closenotification() {
      this.error = null;
    },
    onFileChange1(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.avaceupload = 0;
              _this.query.url = url;
              const result = await apiServices.post(`/uploadnits`, this.query);
              console.log(result);
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
    onFileChange(e) {
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        this.file = this.$refs.file.files[0];
        this.filename = file.name;
      }
    },
    async submitFile() {
      try {
        const _this = this;
        let formData = new FormData();
        formData.append("file", this.file);
        const result = await apiServices.post(`/uploadregistros`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const comprobantes = {};
        for (let index in result.data.comprobantes) {
          const dato = result.data.comprobantes[index];
          comprobantes[dato._id] = dato;
        }
        for (let index in result.data.resumen) {
          const dato = result.data.resumen[index];
          dato.comprobante = comprobantes[dato._id.comprobanteid];
          _this.resumen.push(dato);
        }
        console.log(this.resumen);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Existen errores. No se pudo subir los registros",
          type: "is-danger",
          duration: 4000,
        });
        this.error = err.response.data;
        console.log(this.error);
      }
    },
    async downexemplereg() {
      try {
        let result;
        result = await apiServices.post(
          `/downexemplereg`,
          { np: "np" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    async downexemplenits() {
      try {
        let result;
        result = await apiServices.post(
          `/downexemplenits`,
          { np: "np" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `EjemploNits.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/upload/Upload.vue